import typography from './typography';
import { color } from './color';
import { device } from './utils/responsive';

export default {
  typography,
  color,
  device,
};
